import { cn } from "@/lib/utils";

interface DistanceDisplayProps {
  totalDistance: number;
  elevationGain: number | null;
  visible: boolean;
}

export const DistanceDisplay = ({
  totalDistance,
  elevationGain,
  visible,
}: DistanceDisplayProps) => {
  if (!visible) return null;

  return (
    <div className="absolute bottom-0 z-docked flex h-[80px] w-full items-start gap-8 bg-white p-4 shadow">
      <div className="flex flex-col items-start">
        <p className="text-sm text-gray-500">Distance</p>
        <p
          className={cn(
            "text-lg font-semibold",
            totalDistance > 0 ? "text-gray-500" : "text-gray-300",
          )}
        >
          {(totalDistance / 1000).toFixed(2)} km
        </p>
      </div>
      {elevationGain !== null && (
        <div className="flex flex-col items-start">
          <p className="text-sm text-gray-500">Elevation</p>
          <p className="text-lg font-semibold text-gray-500">
            ↗ {Math.round(elevationGain)} m
          </p>
        </div>
      )}
    </div>
  );
};
